export class FetchElectricMetersAction {
  static readonly type = '[Electric Meter] Fetch Electric Meters';
}
